import type { CategoryHighlight } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSCTA, CMSPageSection } from '@swf/cms';

import CMSCategoryHighlightItem from './CMSCategoryHighlightItem';

const CMSCategoryHighlight: React.FC<CategoryHighlight> = ({ items, heading, intro, cta }) => (
  <>
    <CMSPageSection heading={heading} intro={intro} columns={2} grid>
      {!!items.length &&
        items.map((item, index) => <CMSCategoryHighlightItem {...item} key={index} />)}
    </CMSPageSection>
    <CMSCTA {...cta} />
  </>
);
export default CMSCategoryHighlight;
